export default __webpack_public_path__ + "static/media/PegasGallery1.56f1f649.jpg";